<template lang="pug">
vm-row.heading(vm-w="12")
  vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
    div
      h2 {{ $t('quotations.details_data') }}
  vm-row.heading(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-select(autocomplete :placeholder='$t("quotations.product_placeholder")' :danger="$v.product.name.$invalid && $v.product.name.$model" :danger-text="$t('validation.required', { attribute: $t('quotations.product') })"  v-model="product.name" :label='$t("quotations.product")')
          vm-select-item(:key="index" :value="item.name" :text="item.name" v-for="(item,index) in products")
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-input(type="number" :placeholder='$t("quotations.quantity_placeholder")' :danger="$v.product.quantity.$invalid && $v.product.quantity.$model" :danger-text="$t('validation.required', { attribute: $t('quotations.quantity') })" v-model="product.quantity" :label='$t("quotations.quantity")')
    vm-col(vm-justify="center", vm-align="center", vm-w=3)
      b-form-group.div__quotation
        vm-input(type="number" :placeholder='$t("quotations.price_neto_placeholder")' :danger="$v.product.unit_price.$invalid && $v.product.unit_price.$model" :danger-text="$t('validation.required', { attribute: $t('quotations.unit_price') })" v-model="product.unit_price" :label='$t("quotations.price_neto")')
    vm-col(vm-justify="center", vm-align="center", vm-w=1)
      vm-button.button_add(:disabled="$v.product.$invalid && $v.product.$model" icon="plus" @click="addProduct()")
      vm-button.button_add(icon="close-outline" @click="cancelProduct()" v-if="titleAccion === 'edit_product'")
  vm-row(vm-w="12" class="table-products")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-row.heading(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
        vm-col(vm-justify="center", vm-align="center", vm-w=7)
          v-uploader-file(class="table-products__uploader" only-upload acceptFiles="csv" @drop="onUploadFile" replace=true)
        vm-col(vm-justify="rigth", vm-align="center", vm-w=3)
          vm-button(class="table-products__clear_details" @click="downloadTemplate()" icon="cloud-download-outline") {{ $t('quotations.download_template') }}
        vm-col(vm-justify="rigth", vm-align="center", vm-w=2)
          vm-button(class="table-products__clear_details" @click="deleteAllProducts()" icon="trash-2-outline") {{ $t('quotations.clean_table') }}
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-table(v-model="selected"  max-height="350px" max-items="10" pagination :data="details" )
        template(slot="thead")
          vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
              slot(v-if="column == 'product'")  {{data[indextr]['name'] }}
              slot(v-if="column == 'unit_price'")  {{data[indextr][column] | currency }}
              slot(v-if="column === 'quantity'") {{ data[indextr][column] }}
              slot(v-if="column == 'amount'")  {{data[indextr][column] | currency }}
              slot(v-if="column == 'action'")
                vm-button.actions_products(v-if="titleAccion !== 'edit_product'" type="flat" vm-size="sm" @click="editProduct(data[indextr], tr)" icon="edit-2-outline")
                vm-button.actions_products(v-if="titleAccion !== 'edit_product'" type="flat" vm-size="sm" @click="deleteProduct(data[indextr], tr)" icon="trash-2-outline")
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
import { required, numeric, minValue } from 'vuelidate/lib/validators'
import { VUploaderFile } from '@/components/uploader-file'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'QuotationMasterDetailForm',
  components: {
    VUploaderFile
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['product', 'unit_price', 'quantity', 'amount', 'action'],
    productDefault: false,
    product: {},
    titleAccion: ''
  }),
  validations () {
    return {
      product: {
        name: {
          required
        },
        quantity: {
          required,
          minValue: minValue(1),
          numeric
        },
        unit_price: {
          required,
          minValue: minValue(1)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['products', 'details'])
  },
  watch: {
    details: {
      handler (details) {
        this.$emit('onValidate', {
          valid: this.details.length > 0,
          step: 2
        })
      },
      deep: true
    },
    'product.name' () {
      this.product.unit_price = this.products.find(e => e.name === this.product.name)['unit_price']
    }
  },
  async created () {
    await this.loadProductsCatalog()
  },
  methods: {
    ...mapActions([
      'loadProductsCatalog',
      'addProductDetails',
      'setProductDetails',
      'deleteProducDetail',
      'makeRecordsFromExcel',
      'downloadTemplate'
    ]),
    async addProduct () {
      await this.addProductDetails({
        id: this.productDefault ? this.product.id : Date.now(),
        name: this.product.name,
        unit_price: this.product.unit_price,
        amount: this.product.unit_price * this.product.quantity,
        quantity: this.product.quantity
      })
      this.product = {}
      this.titleAccion = 'add_product'
      this.productDefault = false
    },
    editProduct (data) {
      this.product = { ...data }
      this.titleAccion = 'edit_product'
      this.productDefault = true
    },
    cancelProduct (data) {
      this.product = {}
      this.titleAccion = 'add_product'
    },
    deleteProduct (data) {
      this.deleteProducDetail(data)
    },
    deleteAllProducts (data) {
      this.setProductDetails([])
    },
    onUploadFile (file) {
      this.makeRecordsFromExcel({ file })
    }
  }
}
</script>
<style lang="scss">
.vm-select--label {
  font-weight: bold;
  color: #000;
}
.vm-input--label {
  font-weight: bold;
  color: #000;
}
.vm-typeahead--label {
  font-weight: bold;
  color: #000;
}
.button_add {
  background-color: #000 !important;
}
.table-products {
  padding: 10px;
  background-color: #F2F4F7;
  &__clear_details {
    margin-left: 20px !important;
  }
  &__uplaoder {
    margin-bottom: 25px;
  }
  .vm-table--tbody-table .tr-table tr {
    background-color: #F2F4F7 !important;
  }
  .vm-table--header {
    padding: 0;
  }
}
#app .crud .heading .vm-col:first-child div:last-child {
  padding: 0;
}
.actions_products {
  color: #B1B1B1 !important;
  background-color: transparent !important;
}
</style>
